import { useState } from "react";
import HorseMetrics from "./components/HorseMetrics";

const hIds = [49204, 190723, 195086];

function App() {
  const [selected, setSelected] = useState(hIds[0]);

  const onSelect = (e) => {
    setSelected(+e.target.value);
  };

  return (
    <div>
      <select value={selected} onChange={onSelect}>
        {hIds.map((hId) => (
          <option key={hId} value={hId}>
            {hId}
          </option>
        ))}
      </select>
      <div style={{ marginTop: 24 }}>
        <HorseMetrics hId={selected} />
      </div>
    </div>
  );
}

export default App;
